import React from "react"

interface iProgressCardHeading {
  percentage_complete: number
  Icon: object
}

const ProgressCardHeading: React.FC<iProgressCardHeading> = ({
  percentage_complete,
  Icon,
}) => {
  return (
    <div
      className="flex items-center justify-between px-4 py-4 bg-site-blue"
      style={{ borderTopLeftRadius: "27px", borderTopRightRadius: "27px" }}
    >
      <h1 className="flex items-center text-blue-100">
        <span className="mr-2">{Icon}</span>
        <span>Inputs Filled</span>
      </h1>
      <h1 className="text-blue-100">{percentage_complete.toFixed(1)}&nbsp;%</h1>
    </div>
  )
}
export default ProgressCardHeading
